import { motion } from "framer-motion";

export function Terms() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#03001C] to-[#090024]">
      <main className="container mx-auto px-4 py-16 md:py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="prose prose-invert max-w-3xl mx-auto"
        >
          <h1 className="text-4xl md:text-5xl font-display font-bold bg-gradient-to-r from-white to-white/70 bg-clip-text text-transparent mb-8">
            Terms of Service
          </h1>

          <div className="space-y-8 text-white/80">
            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-4">
                Acceptance of Terms
              </h2>
              <p className="text-white/80">
                By accessing or using AI Code Review's services, you agree to be
                bound by these Terms of Service and all applicable laws and
                regulations. If you do not agree with any of these terms, you
                are prohibited from using or accessing our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-4">
                Use License
              </h2>
              <p className="text-white/80">
                We grant you a limited, non-exclusive, non-transferable license
                to use our services for your personal or business use, subject
                to these terms and any service-specific agreements.
              </p>
              <ul className="list-disc pl-6 mt-4">
                <li>You must not modify or copy our service's source code</li>
                <li>You must not use the service for any illegal purposes</li>
                <li>
                  You must not transmit any malicious code or attempt to harm
                  our services
                </li>
                <li>You must not share your account credentials with others</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-4">
                Service Availability and SLA
              </h2>
              <p className="text-white/80">
                We strive to maintain 99.9% uptime of our services, excluding
                scheduled maintenance. While we aim for high availability, we do
                not guarantee uninterrupted access. We reserve the right to
                modify, suspend, or discontinue any part of our services with
                reasonable notice to users.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-4">
                Payment Terms
              </h2>
              <p className="text-white/80">
                Subscription fees are billed in advance on a monthly or annual
                basis. All fees are non-refundable unless required by law. We
                reserve the right to change our pricing with 30 days notice.
                Failure to maintain valid payment information or pay fees when
                due may result in service suspension.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-4">
                Data Processing and Privacy
              </h2>
              <p className="text-white/80">
                We process personal data in accordance with our Privacy Policy
                and applicable data protection laws, including GDPR where
                applicable. We implement appropriate technical and
                organizational measures to protect your data. By using our
                service, you consent to the collection and processing of your
                data as described in our Privacy Policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-4">
                Code and Content Rights
              </h2>
              <p className="text-white/80">
                You retain all rights to your code and content. By using our
                service, you grant us a limited license to analyze your code for
                the purpose of providing our services. We may use anonymized
                data to improve our AI models. We will not share your private
                code with third parties without your explicit consent.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-4">
                Limitation of Liability
              </h2>
              <p className="text-white/80">
                To the maximum extent permitted by law, AI Code Review shall not
                be liable for any indirect, incidental, special, consequential,
                or punitive damages, or any loss of profits or revenues. Our
                total liability shall not exceed the amount paid by you for the
                service in the 12 months preceding the claim.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-4">
                Termination
              </h2>
              <p className="text-white/80">
                Either party may terminate this agreement with 30 days written
                notice. We may terminate or suspend your access immediately if
                you violate these terms. Upon termination, you will lose access
                to our services, but you may export your data within 30 days of
                termination.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-4">
                Governing Law
              </h2>
              <p className="text-white/80">
                These terms are governed by the laws of the State of Delaware,
                United States, without regard to its conflict of law principles.
                Any disputes shall be resolved in the courts of Delaware, though
                we will respect mandatory local consumer protection laws.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-4">
                User Responsibilities
              </h2>
              <p className="text-white/80">You are responsible for:</p>
              <ul className="list-disc pl-6 mt-4">
                <li>Maintaining the security of your account</li>
                <li>All activities that occur under your account</li>
                <li>Ensuring your use complies with applicable laws</li>
                <li>Backing up your data and code</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-4">
                Intellectual Property
              </h2>
              <p className="text-white/80">
                The service, including its original content, features, and
                functionality, is owned by AI Code Review and is protected by
                international copyright, trademark, and other intellectual
                property laws.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-4">
                Contact Information
              </h2>
              <p className="text-white/80">
                For any questions about these Terms of Service, please contact
                us at{" "}
                <a
                  href="mailto:legal@aicodereview.dev"
                  className="text-blue-400 hover:text-blue-300"
                >
                  legal@aicodereview.dev
                </a>
              </p>
            </section>

            <section className="text-sm text-white/60">
              <p>Last updated: {new Date().toLocaleDateString()}</p>
            </section>
          </div>
        </motion.div>
      </main>
    </div>
  );
}
